<template>
  <div class="disclaimer-section">
    <div class="disclaimer-background"></div>
    <div class="disclaimer-overlay"></div>
    
    <div class="disclaimer-wrapper">
      <div class="disclaimer-header">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="disclaimer-icon">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
        <h3 class="disclaimer-title">Disclaimer Notice</h3>
      </div>
      
      <div class="disclaimer-content">
        <p class="disclaimer-paragraph first-paragraph">
          The information contained in this website is for general information purposes only. While we endeavor to keep the information up to date and correct, we make no representations or warranties of any kind about the completeness, accuracy, reliability, suitability or availability of the website or the information contained on it.
        </p>
        
        <p class="disclaimer-paragraph">
          Any reliance you place on such information is strictly at your own risk. In no event will we be liable for any loss or damage including without limitation, indirect or consequential loss or damage, or any loss or damage whatsoever arising from loss of data or finances in connection with the use of this website.
        </p>
        
        <p class="disclaimer-paragraph">
          Through this website you may link to other websites not under our control. We have no control over the nature, content and availability of those sites. The inclusion of any links does not necessarily imply a recommendation or endorsement of the views expressed within them.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DisclaimerSection',
};
</script>

<style scoped>
.disclaimer-section {
  position: relative;
  padding: 3rem 0;
  overflow: hidden;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
}

.disclaimer-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 50%, #1e40af 100%);
  opacity: 0.15;
  z-index: 0;
}

.disclaimer-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(242, 245, 247, 0.7) 0%, rgba(174, 213, 248, 0.7) 100%);
  z-index: 1;
}

.disclaimer-wrapper {
  position: relative;
  max-width: 85%;
  margin: 0 auto;
  padding: 0 1.5rem;
  z-index: 2;
}

.disclaimer-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.75rem;
}

.disclaimer-icon {
  color: #ef4444;
  flex-shrink: 0;
}

.disclaimer-title {
  font-size: 1.35rem;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
  text-shadow: 0 1px 2px rgba(255,255,255,0.8);
}

.disclaimer-content {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  background-color: rgba(255,255,255,0.85);
  padding: 1.75rem;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
}

.disclaimer-paragraph {
  font-size: 0.95rem;
  line-height: 1.7;
  color: #333;
  margin: 0;
  text-align: justify;
  text-justify: inter-word;
}

.first-paragraph {
  font-weight: 600;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .disclaimer-section {
    padding: 2.25rem 0;
  }
  
  .disclaimer-content {
    padding: 1.5rem;
  }
  
  .disclaimer-header {
    margin-bottom: 1.5rem;
  }
}

@media (max-width: 480px) {
  .disclaimer-section {
    padding: 1.75rem 0;
  }
  
  .disclaimer-wrapper {
    padding: 0 1rem;
  }
  
  .disclaimer-content {
    padding: 1.25rem;
  }
  
  .disclaimer-title {
    font-size: 1.2rem;
  }
  
  .disclaimer-paragraph {
    font-size: 0.875rem;
  }
}
</style>